<template>
  <v-container>
    <div class="home">
      <h1>Vinnie</h1>
      Dit is het medewerkers-gedeelte van Vinnie. Hier activeert de medewerker
      Vinnie voor de cliënt. Ook de rapportages kunnen vanaf hier worden
      ingezien en gedownload. Je moet inloggen om toegang te krijgen als
      medewerker.<br /><br />
      Klik op <router-link to="start">Start sessie</router-link> om te beginnen.
    </div>
  </v-container>
</template>

<script>
export default {
  name: "home",
  components: {},
};
</script>
